export {
  ImageOcclusionCard,
  ImageOcclusionCardProps,
} from './ImageOcclusionCard';
